import React from "react";
import { Row, Col, Card, Container } from "react-bootstrap";
import { StatCard, DataTable } from "../../components/UI";
import CustomIcon from "../../components/UI/CustomIcon";
import { useTheme } from "../../contexts/ThemeContext";
import SEOHead from "../../components/SEO/SEOHead";
import LoadAddForm from "../../components/Forms/load-add-form";

const Dashboard = () => {
  const { getThemeColors } = useTheme();
  const colors = getThemeColors();

  // Sample data for demonstration


  const recentUsersData = [
    {
      id: 1,
      name: "John Doe",
      email: "john@example.com",
      role: "Driver",
      status: "Active",
      joinDate: "2024-01-15",
    },
    {
      id: 2,
      name: "Jane Smith",
      email: "jane@example.com",
      role: "Admin",
      status: "Active",
      joinDate: "2024-01-10",
    },
    {
      id: 3,
      name: "Mike Johnson",
      email: "mike@example.com",
      role: "Manager",
      status: "Inactive",
      joinDate: "2024-01-05",
    },
  ];

  const userColumns = [
    {
      key: "name",
      title: "Name",
      sortable: true,
    },
    {
      key: "email",
      title: "Email",
      sortable: true,
    },
    {
      key: "role",
      title: "Role",
      sortable: true,
    },
    {
      key: "status",
      title: "Status",
      type: "badge",
      badgeVariant: "success",
      render: (value) => (
        <span
          className="badge"
          style={{
            backgroundColor:
              value === "Active" ? colors.success : colors.danger,
            color: "white",
          }}
        >
          {value}
        </span>
      ),
    },
    {
      key: "joinDate",
      title: "Join Date",
      type: "date",
      sortable: true,
    },
  ];

  const userActions = [
    {
      key: "view",
      label: "View",
      icon: "Eyes",
    },
    {
      key: "edit",
      label: "Edit",
      icon: "edit-03",
    },
    {
      key: "delete",
      label: "Delete",
      icon: "trash-03",
    },
  ];

  const handleUserAction = (action, user) => {
  };

  return (
    <>
      <SEOHead
        title="Dashboard"
        description="Comprehensive logistics dashboard. Monitor your freight operations, track loads, manage customers and carriers, and view real-time statistics and analytics."
        keywords="logistics dashboard, freight dashboard, logistics analytics, logistics statistics, operations dashboard, logistics overview"
        url="/dashboard"
      />
      <Container fluid>
    {/* <StatCardExamples/> */}
    <LoadAddForm/>
    {/* <StatCard/> */}
      {/* Charts and Tables Row */}
      {/* <Row>
        <Col lg={8} className="mb-4">
          <Card
            style={{
              backgroundColor: colors.surface,
              border: `1px solid ${colors.border}`,
              boxShadow: `0 2px 8px ${colors.shadow}`,
            }}
          >
            <Card.Header
              style={{
                backgroundColor: colors.gray,
                borderBottom: `1px solid ${colors.border}`,
              }}
            >
              <h5 className="mb-0" style={{ color: colors.text }}>
                Recent Users
              </h5>
            </Card.Header>
            <Card.Body style={{ padding: 0 }}>
              <DataTable
                data={recentUsersData}
                columns={userColumns}
                actions={userActions}
                onAction={handleUserAction}
                searchable
                filterable
                exportable
              />
            </Card.Body>
          </Card>
        </Col>

        <Col lg={4} className="mb-4">
          <Card
            style={{
              backgroundColor: colors.surface,
              border: `1px solid ${colors.border}`,
              boxShadow: `0 2px 8px ${colors.shadow}`,
            }}
          >
            <Card.Header
              style={{
                backgroundColor: colors.gray,
                borderBottom: `1px solid ${colors.border}`,
              }}
            >
              <h5 className="mb-0" style={{ color: colors.text }}>
                Quick Actions
              </h5>
            </Card.Header>
            <Card.Body>
              <div className="d-grid gap-2">
                <button
                  className="btn"
                  style={{
                    background: colors.primaryGradient,
                    color: "white",
                    border: "none",
                    padding: "0.75rem",
                    borderRadius: "8px",
                    fontWeight: "500",
                  }}
                >
                  <CustomIcon name="person" size={20} className="me-2" />
                  Add New User
                </button>

                <button
                  className="btn"
                  style={{
                    backgroundColor: colors.surface,
                    color: colors.text,
                    border: `1px solid ${colors.border}`,
                    padding: "0.75rem",
                    borderRadius: "8px",
                    fontWeight: "500",
                  }}
                >
                  <CustomIcon name="trucka" size={20} className="me-2" />
                  Create Load
                </button>

                <button
                  className="btn"
                  style={{
                    backgroundColor: colors.surface,
                    color: colors.text,
                    border: `1px solid ${colors.border}`,
                    padding: "0.75rem",
                    borderRadius: "8px",
                    fontWeight: "500",
                  }}
                >
                  <CustomIcon name="activity" size={20} className="me-2" />
                  View Reports
                </button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row> */}
    </Container>
    </>
  );
};

export default Dashboard;
